import React, { memo, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import SearchBar from '../home/searchBar';
import D1 from './img/d1.png';
import D2 from './img/d2.png';
import './css/style.scss';
import { X } from 'react-feather';
import { getSummaries } from '../../services/summaryService';
import {
  getSummaryAlertRc,
  getSummaryAnomalyList
} from '../../services/anomalyService';
import { NavLink } from 'react-router-dom';
import SummaryCard from './summaryCard';
import { getComments } from '../../services/otherServices';
import config from '../../configs/config';
import parse from 'html-react-parser';
import { HTMLformatter } from '../../utils/commonFunctions';

const SummaryPage = () => {
  const [summaries, setSummaries] = useState([]);
  const [active, setActive] = useState('');
  const [alerts, setAlerts] = useState([]);
  const [showalert, setShowAlert] = useState(false);
  const [alertsNotFound, setAlertsNotFound] = useState(false);

  useEffect(() => {
    async function getData() {
      let { data } = await getSummaries({
        mindate: '2022-05-07',
        maxdate: '2022-05-07'
      });
      setSummaries(data);
      const temp = [...data];
      await temp.forEach(async (x, i) => {
        temp[i].comment = [];
        try {
          let { data: comment } = await getComments(x.id);
          comment.forEach((y) => {
            temp[i].comment.push(y.comment);
          });
        } catch (err) {
          temp[i].comment = [];
        }
        setSummaries(temp);
      });
    }
    getData();
  }, []);

  const getAlerts = async (x) => {
    setActive(x);
    setShowAlert(true);
    try {
      const { data } = await getSummaryAnomalyList(x);
      let id = [];
      data.forEach((x) => id.push(x.anomaly_id));
      const { data: rcs } = await getSummaryAlertRc(id);
      data.forEach((x) => {
        x.rootcauses = [];
        rcs.forEach((y) => {
          if (x.anomaly_id === y.anomaly_id) {
            x.rootcauses.push(y.inference);
          }
        });
      });
      setAlerts([...data]);
      setAlertsNotFound(false);
    } catch (error) {
      setAlerts([]);
      setAlertsNotFound(true);
    }
  };

  const feedbackUpdate = async (x, liked) => {
    let data = [...summaries];
    data.forEach((s) => {
      if (x.aan_level === s.aan_level) {
        x.liked = liked;
      }
    });
    setSummaries(data);
  };

  return (
    <div className='summaryPage'>
      <Row xs={12} md={12} lg={12} className='m-0 flex-fill' style={{ overflow: 'auto' }}>
        <Col xs={8} md={8} lg={8} className='summary'>
          <div className='titles'>Welcome to today's bulletin</div>
          <div className='subtitle'>TOP INSIGHTS</div>
          <div className='scroller pr-2 mb-2'>
            {summaries.map((x, i) => {
              return (
                <SummaryCard
                  data={x}
                  key={i}
                  active={active}
                  getAlerts={getAlerts}
                  feedbackUpdate={feedbackUpdate}
                />
              );
            })}
          </div>
        </Col>
        {!showalert && (
          <Col xs={4} md={4} lg={4} className='recommendations'>
            <div className='titles'>Recommended Dashboards</div>
            <div className='scroller'>
              <div className='dashboard-card'>
                
                  <div className='name'>OTIF Dashboard</div>
                  <img src={D1} alt='GMV Global Executive' />

              </div>
              <div className='dashboard-card'>
               
                  <div className='name'>OTIF deep dive dashboard</div>
                  <img src={D2} alt='GMV Global Executive' />
                
              </div>
            </div>
          </Col>
        )}

        {showalert && alerts.length >= 1 && (
          <Col xs={4} md={4} lg={4} className='alerts'>
            <div className='titles d-flex'>
              Alerts Found
              <span className='flex-fill'></span>
              <X
                onClick={() => {
                  setActive('');
                  setShowAlert(false);
                }}
              />
            </div>
            <div className='scroller'>
              {alerts.map((x, i) => {
                return (
                  <div className='alert-card' key={i}>
                    {parse(HTMLformatter(x.inference))}
                    <ul>
                      {x.rootcauses.map((x, i) => {
                        return <li key={i}>{parse(HTMLformatter(x))}</li>;
                      })}
                    </ul>
                    <div className='btnholder'>
                      <NavLink to={'/rootcause/' + x.anomaly_id}>
                        <span className='explore'>Explore Now</span>
                      </NavLink>
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
        )}

        {showalert && !alerts.length && ( // Check for no alerts and render accordingly
          <Col xs={4} md={4} lg={4} className='alerts'>
            <div className='titles d-flex'>
              Alerts Not Found
              <span className='flex-fill'></span>
              <X
                onClick={() => {
                  setActive('');
                  setShowAlert(false);
                }}
              />
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default memo(SummaryPage);
